import Process from 'process';

globalThis.process = Process;